module.exports = __webpack_public_path__ + "img/FUN.c3c2ae34.svg";